import { Skeleton } from "@/components/ui/skeleton";

export function TrackCardSkeleton() {
  return (
    <div className="neuro-base rounded-2xl p-4 animate-pulse">
      <div className="flex items-center gap-4">
        {/* Cover image skeleton */}
        <Skeleton className="w-16 h-16 rounded-xl" />
        
        <div className="flex-1 space-y-2">
          {/* Title skeleton */}
          <Skeleton className="h-4 w-3/4" />
          {/* Artist skeleton */}
          <Skeleton className="h-3 w-1/2" />
        </div>
        
        {/* Action buttons skeleton */}
        <div className="flex gap-2">
          <Skeleton className="w-10 h-10 rounded-xl" />
          <Skeleton className="w-10 h-10 rounded-xl" />
        </div>
      </div>
    </div>
  );
}

export function LeaderboardSkeleton({ count = 10 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="neuro-base rounded-2xl p-4 animate-pulse">
          <div className="flex items-center gap-4">
            {/* Rank skeleton */}
            <Skeleton className="w-8 h-8 rounded-full" />
            
            {/* Cover image skeleton */}
            <Skeleton className="w-14 h-14 rounded-xl" />
            
            <div className="flex-1 space-y-2">
              {/* Title skeleton */}
              <Skeleton className="h-4 w-2/3" />
              {/* Artist skeleton */}
              <Skeleton className="h-3 w-1/3" />
            </div>
            
            {/* Vote count skeleton */}
            <Skeleton className="w-16 h-8 rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function DiscoverSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Main player card skeleton */}
      <div className="neuro-base rounded-3xl p-6">
        <div className="flex flex-col items-center gap-6">
          {/* Large cover skeleton */}
          <Skeleton className="w-64 h-64 rounded-2xl" />
          
          {/* Title and artist */}
          <div className="text-center space-y-2 w-full">
            <Skeleton className="h-6 w-3/4 mx-auto" />
            <Skeleton className="h-4 w-1/2 mx-auto" />
          </div>
          
          {/* Progress bar skeleton */}
          <Skeleton className="h-2 w-full rounded-full" />
          
          {/* Controls skeleton */}
          <div className="flex gap-4">
            <Skeleton className="w-12 h-12 rounded-full" />
            <Skeleton className="w-16 h-16 rounded-full" />
            <Skeleton className="w-12 h-12 rounded-full" />
          </div>
        </div>
      </div>
      
      {/* Feedback area skeleton */}
      <div className="neuro-base rounded-2xl p-4">
        <Skeleton className="h-24 w-full rounded-xl" />
        <div className="flex justify-between mt-4">
          <Skeleton className="h-10 w-24 rounded-lg" />
          <Skeleton className="h-10 w-32 rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export function ProfileSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Header */}
      <div className="neuro-base rounded-3xl p-6">
        <div className="flex items-center gap-6">
          <Skeleton className="w-24 h-24 rounded-full" />
          <div className="space-y-3 flex-1">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-64" />
          </div>
        </div>
      </div>
      
      {/* Stats */}
      <div className="grid grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="neuro-base rounded-2xl p-4">
            <Skeleton className="h-8 w-16 mx-auto mb-2" />
            <Skeleton className="h-4 w-20 mx-auto" />
          </div>
        ))}
      </div>
      
      {/* Tracks list */}
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <TrackCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}
